import styled from "@emotion/styled";

const IntroContent = styled.div`
  display: flex;
  width: 100%;
`;

export default IntroContent;
